import { render, staticRenderFns } from "./invoice-checkbox.vue?vue&type=template&id=70982e14"
import script from "./invoice-checkbox.vue?vue&type=script&lang=js"
export * from "./invoice-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports